import { render, staticRenderFns } from "./ProfileView.vue?vue&type=template&id=763e6926&"
import script from "./ProfileView.vue?vue&type=script&lang=ts&"
export * from "./ProfileView.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileView.vue?vue&type=style&index=0&id=763e6926&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports